import PreviewNavSection from "pages/PreviewPage/PreviewNavSection/PreviewNavSection";

export default PreviewNavSection;
